import styled from 'styled-components';

import { Alert, spaceMixin } from '@zillow/constellation';

import type { FC } from 'react';
import type { AlertProps } from '@zillow/constellation';

export const StyledAlert: FC<React.PropsWithChildren<React.PropsWithChildren<typeof AlertProps>>> = styled(Alert)`
  margin-bottom: ${spaceMixin('md')};
`;
